var hasProp = window.hasProp;
var extend = window.extend;
var CertifierNominationsStore = window.CertifierNominationsStore;
var CertifierNominationsStore,
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
CertifierNominationsStore = function (superClass) {
  extend(CertifierNominationsStore, superClass);
  CertifierNominationsStore.MAX_NOMINATIONS = 3;
  CertifierNominationsStore.prototype.nominations = function () {
    return this.nominationsList;
  };
  CertifierNominationsStore.prototype.totalNominations = function () {
    if (!this.preexistingNominations) {
      return CertifierNominationsStore.MAX_NOMINATIONS;
    }
    return CertifierNominationsStore.MAX_NOMINATIONS - this.preexistingNominations.length;
  };
  CertifierNominationsStore.prototype.nominationsLeft = function () {
    var nominationsUsed;
    nominationsUsed = 0;
    if (this.nominationsList && this.preexistingNominations) {
      nominationsUsed = this.nominationsList.length + this.preexistingNominations.length;
    }
    return CertifierNominationsStore.MAX_NOMINATIONS - nominationsUsed;
  };
  CertifierNominationsStore.prototype.madeNominations = function () {
    return this.nominationsList.length > 0;
  };
  CertifierNominationsStore.prototype.takenNominations = function () {
    return this.nominationsList;
  };
  function CertifierNominationsStore() {
    CertifierNominationsStore.__super__.constructor.call(this);
    this.dispatcherCallback('certifier-nominate', this.onCertifierNominate);
    this.dispatcherCallback('certifier-remove-nomination', this.onCertifierRemoveNomination);
    this.dispatcherCallback('certifier-nominations-confirm', this.onCertifierNominationsConfirm);
  }
  CertifierNominationsStore.prototype.onCertifierNominate = function (payload) {
    if (!(this.nominationsLeft() > 0)) {
      return;
    }
    this.nominationsList.push(payload.nominatedProfile);
    return this.emitChange();
  };
  CertifierNominationsStore.prototype.onCertifierRemoveNomination = function (payload) {
    this.removeNomination(payload.removedProfile);
    return this.emitChange();
  };
  CertifierNominationsStore.prototype.onCertifierNominationsConfirm = function (payload) {
    if (this.madeNominations()) {
      return this.createNominationsAndRedirect();
    } else {
      return this.nextPage();
    }
  };
  CertifierNominationsStore.prototype.hasData = function () {
    return this.nominationsList != null;
  };
  CertifierNominationsStore.prototype.loadData = function () {
    var error, success, url;
    url = $r.api_v0_certifications_certifier_nominations_path({
      subdomain_param: 'api',
      nominator_id: Aedu.User.current.id
    });
    success = function (_this) {
      return function (data) {
        _this.nominationsList = [];
        _this.preexistingNominations = data.certifier_nominations;
        return _this.emitChange();
      };
    }(this);
    error = function (_this) {
      return function (data) {
        return alert('Something went wrong. Please try again in a few moments.');
      };
    }(this);
    return this.readFromUrl(url, success, error);
  };
  CertifierNominationsStore.prototype.removeNomination = function (deletedProfile) {
    return this.nominationsList = _.reject(this.nominationsList, function (profile) {
      return profile.id === deletedProfile.id;
    });
  };
  CertifierNominationsStore.prototype.createNominationsAndRedirect = function () {
    var data, error, nomineeIds, success, url;
    nomineeIds = _.map(this.nominationsList, function (nomination) {
      return nomination.id;
    });
    url = $r.api_v0_certifications_certifier_nominations_path;
    data = {
      subdomain_param: 'api',
      nominee_ids: nomineeIds,
      nominator_id: Aedu.User.current.id
    };
    success = function (_this) {
      return function (response) {
        return _this.nextPage();
      };
    }(this);
    error = function (_this) {
      return function (response) {
        return alert('Could not connect to server to complete nomination process. Please try again.');
      };
    }(this);
    return this.createAtUrl(url, data, success, error);
  };
  CertifierNominationsStore.prototype.nextPage = function () {
    return document.location = "/recommendations/suggestions";
  };
  return CertifierNominationsStore;
}(Flux.Store);
Flux.Certifications.CertifierNominationsStore = new CertifierNominationsStore();
window.CertifierNominationsStore = CertifierNominationsStore;
window.extend = extend;
window.hasProp = hasProp;